import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserCog, ShieldCheck, ShieldOff, ShieldAlert, FileSignature, Scale, PhoneCall, Users2, AlertTriangle, LineChart } from "lucide-react";

const CARDS = [
    {
        to: "/gobierno/delegados",
        title: "Libro de Delegados",
        subtitle: "Alta, revocación y suspensión de delegados fiduciarios",
        icon: UserCog,
        badge: "G-01 §7",
    },
    {
        to: "/gobierno/matriz-autorizacion",
        title: "Matriz de Autorización",
        subtitle: "Escalones por monto · firmas requeridas · call-back · VB DG",
        icon: Scale,
        badge: "Runtime",
    },
    {
        to: "/gobierno/call-backs",
        title: "Confirmaciones Telefónicas",
        subtitle: "Registro de call-backs con hash de evidencia y grabación",
        icon: PhoneCall,
        badge: "MOCK grabación",
    },
    {
        to: "/gobierno/comite/sesiones",
        title: "Comité Fiduciario",
        subtitle: "Sesiones, quórum, asuntos, votación y actas PDF",
        icon: Users2,
        badge: "Interno",
    },
    {
        to: "/gobierno/comite/miembros",
        title: "Miembros del Comité",
        subtitle: "Presidente · Secretario · Vocales activos",
        icon: ShieldCheck,
    },
    {
        to: "/gobierno/conflictos",
        title: "Conflictos de Interés",
        subtitle: "Auto-declaración con medidas de mitigación",
        icon: AlertTriangle,
        badge: "Trimestral",
    },
    {
        to: "/gobierno/reporte-consejo",
        title: "Reporte al Consejo",
        subtitle: "Consolidado trimestral: fideicomisos, delegados, dictámenes, PLD",
        icon: LineChart,
    },
];

export default function GobiernoHub() {
    return (
        <div className="p-8 lg:p-10 space-y-6 max-w-[1400px]" data-testid="gobierno-hub">
            <div>
                <div className="text-[11px] uppercase tracking-[0.3em] text-[color:var(--brand-dark-gold)] font-semibold mb-2">
                    Fase 14
                </div>
                <h1 className="font-display text-4xl tracking-tight">Gobierno Fiduciario</h1>
                <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
                    Órgano interno de segregación de funciones, control y aprobación colegiada
                    conforme al Marco Normativo v1.0 (G-01 §7).
                </p>
            </div>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {CARDS.map((c) => (
                    <Link
                        key={c.to}
                        to={c.to}
                        className="kpi-card hover:shadow-lg transition-all group"
                        data-testid={`gobierno-card-${c.to.split("/").pop()}`}
                    >
                        <div className="flex items-center justify-between">
                            <c.icon className="h-5 w-5 text-[color:var(--brand-dark-gold)]" />
                            {c.badge && <span className="badge-gold text-[10px]">{c.badge}</span>}
                        </div>
                        <div className="mt-3 font-display text-xl group-hover:text-[color:var(--brand-dark-gold)] transition-colors">
                            {c.title}
                        </div>
                        <div className="text-xs text-muted-foreground mt-1 leading-relaxed">
                            {c.subtitle}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
